module.exports = __webpack_public_path__ + "img/task-bg.731827e7.png";